import type { IReportEntityMap } from '../reports/report-builder/02-entity-configuration/mw-reports/utils';

export type GlobalAssistantReportAccessDecision =
  | { allowed: true }
  | {
      allowed: false;
      reportName: string;
      message: string;
    };

const getGlobalAssistantReportAccessMessage = (reportName: string): string =>
  `Your account currently doesn't have access to the ${reportName} report, please contact your Revelio representative.`;

export function getGlobalAssistantReportAccess(
  reportType: string,
  reportName: string,
  reportEntityMap: IReportEntityMap,
  promotedTemplateAvailable = false
): GlobalAssistantReportAccessDecision {
  if (reportEntityMap[reportType] || promotedTemplateAvailable) {
    return { allowed: true };
  }
  return {
    allowed: false,
    reportName,
    message: getGlobalAssistantReportAccessMessage(reportName),
  };
}
